import { ChatRecipients } from 'constants/chat-recipients';
import { WebSocketAction } from 'constants/web-socket-action';
import { getServer } from 'helpers/get-server';
import {
  type SendMessageEvent,
  type SendSystemMessageEventBody,
  type SendSystemMessagePayload,
} from 'interfaces/web-socket-events';

import { sendEvent } from './send-event';

/**
 * @see https://platform.text.com/docs/messaging/agent-chat-api/rtm-reference#send-event
 */
export async function sendSystemMessage({
  messageText,
  chatId,
  isWhisper,
  systemMessageType,
}: SendSystemMessagePayload): Promise<unknown> {
  const messageEvent: SendSystemMessageEventBody = {
    type: 'system_message',
    text: messageText,
    visibility: isWhisper ? ChatRecipients.Agents : ChatRecipients.All,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    system_message_type: systemMessageType,
  };

  const event: SendMessageEvent = {
    action: WebSocketAction.SendEvent,
    payload: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      chat_id: chatId,
      event: messageEvent,
    },
    version: '3.5',
  };

  return await sendEvent<unknown>(getServer(), event);
}
